import { StateEnum } from '@model/enum/state.enum';

export const getState = ({
  isLoading,
  isFetching,
  isError,
}: {
  isLoading: boolean;
  isFetching?: boolean;
  isError: boolean;
}): StateEnum => {
  if (isLoading || isFetching) {
    return StateEnum.LOADING;
  }
  if (isError) {
    return StateEnum.ERROR;
  }
  return StateEnum.SUCCESS;
};
